import React from "react";
import DepartmentHome from "../components/DepartmentHome.jsx";

const items = [
  ["Users & Access", "/admin/users", "Manage who can log in and take training"],
  ["Multi-Branch", "/admin/enterprise", "Branches, security settings and launch checklist"],
  ["Data Migration", "/admin/data-migration", "Import data from your previous system"],
];

const icons = {
  "Users & Access": "🔑",
  "Multi-Branch": "🏢",
  "Data Migration": "🔄",
};

export default function AdministrationHome() {
  return (
    <DepartmentHome
      title="Administration"
      description="User access, multi-branch setup, and data migration."
      items={items}
      icons={icons}
    />
  );
}
